import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** The shadcn/ui class combiner — every component in components/ui uses it. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
